import React from 'react';
import ReactDOM from 'react-dom';
import CloseIconBlack from '../static/images/black_icons/x_icon_black.png';
import CloseIconWhite from '../static/images/x_icon.png';
import { useTheme } from '../theme/ThemeContext';

const AlertComponent = ({ header, message, isVisible, onClose, autoClose = false }) => {
    const { theme } = useTheme();
    const CloseIcon = theme.name === 'light' ? CloseIconBlack : CloseIconWhite;

    React.useEffect(() => {
        if (isVisible && autoClose) {
            const timer = setTimeout(() => {
                onClose();
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [isVisible, onClose, autoClose]);

    const containerStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10000000,
        backgroundColor: theme.colors.overlay,
        backdropFilter: 'blur(5px)',
        WebkitBackdropFilter: 'blur(5px)',
        animation: 'fadeBackdrop 0.3s ease-in-out',
    };

    const popupStyle = {
        maxWidth: '400px',
        padding: '30px',
        backgroundColor: theme.colors.overlay,
        color: '#fff',
        borderRadius: '8px',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        animation: 'fadeIn 0.3s ease-in-out',
        position: 'relative',
    };

    const contentStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',

        gap: '10px',
        margin: '10px 50px 10px 50px',
    };

    const closeIconStyle = {
        position: 'absolute',
        top: '10px',
        right: '10px',
        width: '20px',
        height: '20px',
        cursor: 'pointer',
    };

    const headerStyle = {
        color: theme.colors.text,
        fontFamily: 'Arial',
        margin: 0,
    };

    const messageStyle = {
        color: theme.colors.text,
        fontFamily: 'Arial',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        hyphens: 'auto',
    };


    if (!isVisible) return null;

    const modalContent = (
        <div style={containerStyle}>
            <style>
                {`
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(-20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes fadeBackdrop {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                `}
            </style>
            <div style={popupStyle}>
                <img
                    src={CloseIcon}
                    alt="Close"
                    style={closeIconStyle}
                    onClick={onClose}
                />
                <div style={contentStyle}>
                    <h3 style={headerStyle}>{header}</h3>

                    <span style={messageStyle}>{message}</span>
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(modalContent, document.body);
};

export default AlertComponent;